import React, { Fragment, useState, useRef, useEffect } from 'react';
import {
  isAuthenticated,
  getUserIdFromJwt,
  getUserFromJwt
} from '../../util/jwt';
import SignInIcon from '../../util/icons/components/SignInIcon';
import DropDownIcon from '../../util/icons/components/DropDownIcon';
import { useSelector, useDispatch } from 'react-redux';
import { getUsersObj } from '../../admin/userAdmin/reducer';
import { getOrgsObj } from '../../admin/orgAdmin/reducer';
import { NavLink, useHistory } from 'react-router-dom';
import { logout } from '../../user/actions';
import './account.scss';
import { fetchUser } from '../../admin/userAdmin/actions';
import { fetchOrg } from '../../admin/orgAdmin/actions';

const Account = () => {
  const [ menuOpen, setMenuOpen ] = useState(false);
  const users = useSelector(getUsersObj);
  const orgs = useSelector(getOrgsObj);
  const user = users[getUserIdFromJwt()];
  const dispatch = useDispatch();
  if (isAuthenticated() && (!users || Object.keys(users).length < 1)) {
    dispatch(fetchUser(getUserIdFromJwt()));
  }
  let org = '';
  useEffect(() => {
    if (user && user.orgIds && user.orgIds.length) {
      org = orgs[user.orgIds[0]];
      if (!org && Object.keys(orgs).length < 1 && isAuthenticated()) {
        dispatch(fetchOrg(user.orgIds[0]));
      }
    }
  }, []);
  const ref = useRef();
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);
  const handleDocumentClick = event => {
    if (!ref.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };
  const history = useHistory();
  const handleComponentClick = event => {
    if (isAuthenticated()) {
      setMenuOpen(!menuOpen);
    } else {
      history.push('/login');
    }
  };
  const handleLogoutClicked = event => {
    event.preventDefault();
    event.stopPropagation();
    setMenuOpen(false);
    history.push('/');
    dispatch(logout());
  };
  const login = isAuthenticated() ? null : (
    <Fragment>
      <SignInIcon />
      <span className="login-text">Login</span>
    </Fragment>
  );
  let userName = user ? user.name : '';
  let orgName = org ? org.name : '';
  if (!userName || !orgName) {
    const jwtUser = getUserFromJwt();
    if (!userName) userName = jwtUser.name;
    if (!userName) userName = jwtUser.email;
    if (!orgName) orgName = 'GoodBeef Index';
  }

  const userData = isAuthenticated() ? (
    <Fragment>
      <div className="name">{ userName }</div>
      <div className="org">{ orgName }</div>
      <DropDownIcon />
    </Fragment>
  ) : null;
  const menuClass = menuOpen ? 'account-component-menu visible' :
    'account-component-menu hidden';
  const menu = isAuthenticated() ? (
    <div className={ menuClass }>
      <NavLink to="/account/my-account"
        activeClassName="active">
        <div className="component-menu-item">
          Account
        </div>
      </NavLink>
      <NavLink to="/"
        activeClassName="active">
        <div onClick={ handleLogoutClicked }
          data-cy="account-logout-option"
          className="component-menu-item">
          <SignInIcon /> <span className="logout-text">Logout</span>
        </div>
      </NavLink>
    </div>
  ) : null;
  const mainClass = isAuthenticated() ? 'user-account-component logged-in' :
    'user-account-component logged-out';
  return (
    <div className={ mainClass }
      data-cy="account-component"
      ref={ ref }
      onClick={ handleComponentClick }>
      { login }
      { userData }
      { menu }
    </div>
  );
};

export default Account;
